import { BASE_API_URL } from '../config.js';
import { all_hymos,customer_list, alarm_recipient_list, all_compound_water_meters, current_sample_time, current_device_data_additional_values, free_hymos, water_meter_alarms_triggered_old, water_meter_alarms_triggered_new, free_water_meters, hymo_alarms_triggered_new, hymo_alarms_triggered_old, all_water_meters, last_meta_data, current_device_data, is_loading_current_device_data, user_list, all_water_meter_boxes, extended_device_channel_list, selected_device } from "../stores.js";


export async function fetchVehicles() {
    try {
        
                        let url_extension = "/vehicles/";
            let request_url = BASE_API_URL + url_extension;
        const response = await fetch(
            request_url,     {
            method: "GET",
            headers: {
                Authorization: `Token ${sessionStorage.getItem(
                    "2kai_access_token",
                )}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            // handle_bad_response(response);
            return false;
        }
        let data = await response.json();
        return data;
    }
    catch (error) {
        console.error("Error fetching vehicles:", error);
        return [];
    }
}

// export async function fetchAlarms() {
//     try {
//         const response = await fetch("http://localhost:8000/api/vehicles", {
//             method: "GET",
//             headers: {
//                 Authorization: `Token ${sessionStorage.getItem(
//                     "2kai_access_token",
//                 )}`,
//                 "Content-Type": "application/json",
//             },
//         });
//         if (!response.ok) {
//             // handle_bad_response(response);
//             return false;
//         }
//         let data = await response.json();
//         return data;
//     }
//     catch (error) {
//         console.error("Error fetching vehicles:", error);
//         return [];
//     }
// }

// fetching all current_alarms
export async function get_alarms_current_vehicles(hymo_group="vehicles") {
    let url_extension = "/alarms_current_" + hymo_group + "/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let data = await response.json();
        hymo_alarms_triggered_new.set(data);
        return true;

    } catch (error) {
        return false;
    }

}

// fetching all old alarms
export async function get_alarms_old_vehicles(hymo_group="vehicles") {
    let url_extension = "/alarms_old_" + hymo_group + "/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let data = await response.json();
        hymo_alarms_triggered_old.set(data);
        return true;

    } catch (error) {
        return false;
    }


}